export default "__VITE_ASSET__DX2ET2iy__"